import React, { Fragment, useState, useEffect } from 'react';
import {
  AssociationWrapper,
  AssociationLogosWrapper
} from './Association.style';
import { useTranslation } from 'react-i18next';
import associations from 'settings/associations';

const Association = ({ associationType, view, marinaName }) => {
  const { t } = useTranslation();

  const getAssociation = () => {
    if (associationType) {
      return associations[associationType];
    }
  };

  const association = getAssociation();

  if (!association && view === 'marinaSinglePage') {
    return null;
  }

  return (
    <Fragment>
      {view === 'marinaSinglePage' && association ? (
        <AssociationWrapper>
          <h4 className='title'>{t('MEMBER_OF')}</h4>
          <div className='logos'>
            <div className='logo-item'>
              <img
                src={association.logo}
                alt={association.name}
                width={association.width}
              />
              <p className='association-name'>{association.name}</p>
            </div>
          </div>
        </AssociationWrapper>
      ) : association ? (
        <AssociationLogosWrapper>
          <img
            src={association.logo}
            alt={association.name}
            width={association.width}
          />
        </AssociationLogosWrapper>
      ) : (
        <AssociationLogosWrapper />
      )}
    </Fragment>
  );
};

export default Association;
